<template>
    <div v-if="addon" class="checkout-sms">
        <CheckboxField
            :name="addon.Id"
            @update:modelValue="(value: boolean) => onUpdateValue(value)">
            <div class="checkout-sms-content">
                {{ label }}
            </div>
        </CheckboxField>
    </div>
</template>

<script lang="ts">
    import { computed, defineComponent, PropType } from 'vue';
    import { AddonProduct } from '@/api/Cart/cart.interfaces';
    import { t } from '@shared/helpers/translation';
    import { getMoneyObjectAsString } from '@shared/helpers/money';
    import CheckboxField from '@ui/components/FormV2/Fields/Checkbox/CheckboxField.vue';

    export default defineComponent({
        name: 'SMSAddon',
        methods: { t },
        components: { CheckboxField },
        emits: ['update:modelValue'],
        props: {
            addon: {
                type: Object as PropType<AddonProduct>,
                required: true,
            },
        },
        setup(props, { emit }) {
            const label = computed(() => {
                const price = getMoneyObjectAsString(props.addon?.Price);

                return props.addon?.Price?.Amount
                    ? t({
                          key: 'checkout.add_sms_confirmation',
                          values: [price],
                      })
                    : null;
            });

            function onUpdateValue(state: boolean) {
                emit('update:modelValue', state);
            }

            return {
                label,
                onUpdateValue,
            };
        },
    });
</script>

<style lang="scss" scoped>
    @forward './SMSAddon.scss';
</style>
